module.exports = __webpack_public_path__ + "static/media/promo_natural_stone_v2.3f253575.png";